import { Campaign, CampaignStatisticsUser, Tip } from '@hub/shared'
import { SqMetricChartCard } from '@squidit/react-css'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface SectionShareLinksComponentProps {
  campaign: Campaign
  statisticsUser: CampaignStatisticsUser
}
const SectionShareLinksComponent = ({ campaign, statisticsUser }: SectionShareLinksComponentProps) => {
  const { t } = useTranslation('reportPage')

  const metricsShareLink = useMemo(
    () => [
      {
        value: 'totalClicks',
        percentage: false,
        metric: statisticsUser?.['totalClicks']?.['clicks'],
      },
      {
        value: 'uniqueClicks',
        percentage: false,
        metric: statisticsUser?.['uniqueClicks']?.['uniqueClicks'],
      },
      {
        value: 'ctr',
        percentage: false,
        metric: statisticsUser?.['ctr']?.['ctr'],
      },
    ],
    [statisticsUser]
  )

  const metricsConversion = useMemo(
    () => [
      {
        value: 'convertions_count',
        percentage: false,
        metric: statisticsUser?.['convertions_count']?.['convertions_count'],
      },
      {
        value: 'convertions_registered_count',
        percentage: false,
        metric: statisticsUser?.['convertions_registered_count']?.['convertions_registered_count'],
      },
      {
        value: 'convertions_value',
        percentage: false,
        metric: statisticsUser?.['convertions_value']?.['convertions_value'],
      },
      {
        value: 'convertions_registered_value',
        percentage: false,
        metric: statisticsUser?.['convertions_registered_value']?.['convertions_registered_value'],
      },
      {
        value: 'convertions_commission_to_receive',
        percentage: false,
        metric: statisticsUser?.['convertions_commission_to_receive']?.['convertions_commission_to_receive'],
      },
    ],
    [statisticsUser]
  )

  const hasMetricConvertions = useMemo(() => metricsConversion.every((currentValue) => currentValue?.metric.user > 0), [metricsConversion])

  if (!campaign?.activation?.hasTrackLink || !statisticsUser) {
    return null
  }

  return (
    <div>
      <div className="content-type-metric">
        <h5>
          {t('shareLinks.title')}
          <Tip className="ml-2" message={t('shareLinks.helpText')} place="top" icon={'fa-regular fa-circle-info'} />
        </h5>

        {metricsShareLink?.map((item, index) => (
          <SqMetricChartCard
            key={`${item?.value}-${index}`}
            className="mb-3"
            title={t(`${item?.value}`)}
            metric={item?.metric}
            percentage={item?.percentage}
            type={item?.value}
          />
        ))}
      </div>
      {hasMetricConvertions ? (
        <div className="content-type-metric">
          <h5>
            {t('conversions.title')}
            <Tip className="ml-2" message={t('conversions.helpText')} place="top" icon={'fa-regular fa-circle-info'} />
          </h5>
          {hasMetricConvertions}
          {metricsConversion?.map((item, index) => (
            <SqMetricChartCard
              key={`${item?.value}-${index}`}
              className="mb-3"
              title={t(`${item?.value}`)}
              metric={item?.metric}
              percentage={item?.percentage}
              type={item?.value}
            />
          ))}
        </div>
      ) : null}
    </div>
  )
}
export default SectionShareLinksComponent
